import { object, string, boolean } from 'yup'

export interface IRefreshNormFileSchema {
  googleSheetsUrl: string
  email: string
  draftRound: boolean
}

export const RefreshNormFileSchema = object<IRefreshNormFileSchema>({
  googleSheetsUrl: string().required('Must enter a URL'),
  email: string().required('Must enter an email address'),
  draftRound: boolean(),
})
